import gql from 'graphql-tag';

export const GRAPHQL_QUERY_RECEIPTS = gql`
    query receipts($criteria:CriteriaInput){
        receipts(criteria: $criteria){
            rows{
                id
                isFirstOrder
                userHasLoyaltyCard
                isDeleted
                rating
                isPro
                createdAt
                mobilePhone
                comments {
                    id
                    review
                }
                user{
                    firstName
                    lastName
                    email
                    id
                    birthDate
                    civility
                    mobilePhone
                    barcode
                }
                brand{
                    id
                    name
                    createdAt
                    updatedAt
                }
                file{
                    id
                    key
                    token
                    filename
                    mimeType
                    size
                }
                checkout{
                    id
                    name
                }
                merchant{
                    id
                    businessName
                    user{
                        id
                        firstName
                        lastName
                    }
                }
                tags {
                    id
                    rows {
                        id
                        name
                    }
                }
            }
            total
            id
        }
    }
`;


export const GRAPHQL_MUTATION_DELETE_RECEIPT = gql`
    mutation deleteReceipt($receiptId: ID!) {
        deleteReceipt(receiptId: $receiptId)
    }
`;
